import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg className={styles["ArrowTooltip"] || "ArrowTooltip"} width="12" height="6" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M0 6l6-6 6 6z" fill="#19D5A1" fillRule="evenodd" /></svg>);